import React, { Component } from 'react';

class Renders extends Component {
  render() {
    return (
      <section>
        <h1>Renders will be here</h1>
      </section>
    );
  }
}

export default Renders;
